import React from 'react'
import {Link } from "react-router-dom";

function Header() {
  return (
    <div className='headerMain'>
        <h1 className='header'>Nutri-Scan</h1>
    </div>
  )
}

export default Header